import { Component, OnInit, Inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/dialog.component';
import { Assessment, AccountAssessment } from 'src/app/models/AssessmentModel';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { SessionService } from 'src/app/services/session.service';
import { PlatformApiService, PlanSearchCriteria, ResultFilter } from 'src/app/services/platform-api.service';
import { Account, Plan } from 'src/app/models/AccountModel';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { InfiniteScrollOption } from 'src/app/shared/infinite-scroll-select.component';

@Component({
  selector: 'cw-ci-certification-assessment-list',
  templateUrl: './certification-assessment-type-list.component.html',
  styleUrls: ['./certification-assessment-type-list.component.scss'],
})

export class CertificationAssessmentTypeListComponent implements OnInit {
  @Input() account: Account;
  @ViewChild(DialogComponent, { static: true }) cwdialog: DialogComponent;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  public assessmentTypeForm: FormGroup;
  public stateCtrl: FormControl;

  cancelButton = true;
  showCloseButton = true;
  isLoading = true;
  dialogTitle:string;
  associatedAssessmentID: string;

  @Input()
  dialogMessage:string;
  buttonText:string;
  cancelButtonText = 'Cancel';
  assessmentList:  any;
  assessmentDetails: any;
  planId: number;
  isInTrial: boolean;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService, public dialog: MatDialog, public dialogRef: MatDialogRef<CertificationAssessmentTypeListComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.assessmentTypeForm = new FormGroup ({
      assessment: new FormControl({value: '', disabled: true }, [Validators.required]),
      accountNameDropdown:  new FormControl('', [Validators.required]),
    })

    this.stateCtrl = new FormControl();

    if (this.data.account == undefined) {
      this.assessmentTypeForm.controls.accountNameDropdown.valueChanges.subscribe(result => {
        this.isLoading = true;
        this.assessmentTypeForm.get('assessment').disable();
        this._platformApi.getPlans(new PlanSearchCriteria(true, undefined, undefined, undefined, result.value)).subscribe(plans => {
          const planObj = plans.results[0];
          if (planObj && result.value) {
            this._platformApi.getPaymentStatus(result.value).subscribe(status => {
              const isTrialAccount = status.paymentStatus.toLowerCase() == 'trial'? true : false;
              let isAllowCertification = planObj.features.filter(({ featureType }) => featureType.includes('ALLOW_CERTIFICATION'));
              isAllowCertification = isTrialAccount == true ? isAllowCertification[0].trialValue : isAllowCertification[0].value;
              if (isAllowCertification) {
                this._platformApi.getAssessments(new ResultFilter(undefined, undefined, undefined,undefined, {planId: status.plan.id, isInTrial: isTrialAccount, includeTypeList: ['CERTIFICATION']}))
                .subscribe(assessmentTemplates => {
                  if (assessmentTemplates.count > 0) {
                    this.isLoading=false;
                    this.assessmentTypeForm.get('assessment').enable();
                    this.assessmentTypeForm.controls.assessment.setErrors({isPlanExist: false});
                    if (assessmentTemplates.count == 1) {
                      this.assessmentTypeForm.controls.assessment.setValue(new InfiniteScrollOption(assessmentTemplates.results[0].name, assessmentTemplates.results[0].id, false, true, true));
                    }
                    this.assessmentTypeForm.controls.assessment.updateValueAndValidity();
                  } else {
                    this.validateAccount();
                    return this.assessmentTypeForm.controls.assessment.setErrors({ isPlanExist: true});
                  }
                })
              } else {
               this.validateAccount();
               return this.assessmentTypeForm.controls.assessment.setErrors({ isCertificationEnabled: true});
              }
            });
          }
        })
      })
    }
  }

  ngOnInit() {
    this.dialogTitle = 'Add Certification';
    this.dialogMessage = 'Please select the company and certification assessment below.';
    this.buttonText = 'Save';
    this.isLoading = false;
    this.assessmentTypeForm.get('assessment').enable();
    // for inline add action
    if (this.data.account) {
      this.stateCtrl.disable();
      const accountName = this.data.account.accountName;
      this.assessmentTypeForm.controls.accountNameDropdown.setValue({ description: accountName });
      this.associatedAssessmentID = this.data.account.assessmentId;
      this.planId = this.data.planId;
      this.isInTrial = this.data.isInTrial;
      this.assessmentTypeForm.controls.assessment.updateValueAndValidity();
      if(this.data.defaultValue) {
        this.assessmentTypeForm.controls.assessment.setValue(new InfiniteScrollOption(this.data.defaultValue.name, this.data.defaultValue.id, false, true, true));
      }
    }

    if (this.data.assessmentList) {
      this.stateCtrl.enable();
      this.assessmentList = this.data.assessmentList;
    }

    // close  action
    if (this.dialogRef.disableClose) {
      this.showCloseButton = false;
      this.cancelButton = false;
    }
  }

  buttonAction(value?: any): void {
    this.dialogRef.close();
  }

  addAssessment(value?: any) {
    this.cwdialog.spinner.showSpinner('Saving...');
    const selectedAssesmentId = this.assessmentTypeForm.value.assessment.value;
    this.assessmentTypeForm.controls.assessment.markAllAsTouched();
    if (this.assessmentList == undefined) {
      const accountId = this.data.account.accountId;
        this._platformApi.getAccountAssessments(accountId, undefined).subscribe(results => {
          const assessmentDetails = results;
          this.assessmentDetails = assessmentDetails.results.filter(u => u.assessmentType.toLowerCase() == 'certification');
          this.recentAssessmentStatus(accountId, selectedAssesmentId, this.assessmentDetails );
        });
    } else {
      const selectedAccountId = this.assessmentTypeForm.value.accountNameDropdown.value;
      this.recentAssessmentStatus(selectedAccountId, selectedAssesmentId, this.assessmentList.results);
    }
  }

  recentAssessmentStatus(selectedAccountId, selectedAssesmentId, assessmentList ) {
    const recentAssessments  = assessmentList.filter(u => u.accountId == selectedAccountId && u.isLatest == 1);
      if (recentAssessments.length > 0 ) {
          if (recentAssessments[0].status.toLowerCase() != 'completed') {
            this.assessmentInProgress();
          } else if (recentAssessments[0].status.toLowerCase() == 'completed' && recentAssessments[0].assessmentId == selectedAssesmentId) {
            this.cwdialog.spinner.hideSpinner();
            this.displayConfirmationComponent(recentAssessments[0]);
          } else {
            this.newAssessmentSurvey(selectedAccountId, selectedAssesmentId, recentAssessments[0]);
          }
      } else {
        this.newAssessmentSurvey(selectedAccountId, selectedAssesmentId, undefined)
      }
  }

  newAssessmentSurvey(selectedAccountId, selectedAssesmentId, recentAssessments) {
    const newAccountAssessment = new AccountAssessment({
      accountId: selectedAccountId,
      assessmentId: selectedAssesmentId,
      prevId: recentAssessments == undefined ? null : recentAssessments.id,
      surveyResultsJson: null
    });

    if (recentAssessments == undefined) {
      this._platformApi.saveAccountAssessment(undefined, newAccountAssessment).subscribe(accountAssessment => {
        this.cwdialog.spinner.hideSpinner();
        this.dialogRef.close();
      });
    } else {
      this._platformApi.saveAccountAssessment(undefined, newAccountAssessment).subscribe(accountAssessment => {
        recentAssessments.nextId = accountAssessment.id;
        recentAssessments.isLatest = false;
        this._platformApi.saveAccountAssessment(undefined, recentAssessments).subscribe(prevAcctAssessment => {
          this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: selectedAccountId });
          this.cwdialog.spinner.hideSpinner();
          this.dialogRef.close();
        });
      })
    }
  }

  displayConfirmationComponent(loadedAssessment){
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Copy Answers',
        promptMessage: [
          'Do you want to copy the existing answers for this assessment into the new assessment?'
        ],
        closeLabel: 'Cancel',
        buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(keepAnswers => {
      if (keepAnswers != undefined) {
        this.cwdialog.spinner.showSpinner('Saving...');
          const newAccountAssessment = new AccountAssessment({
            accountId: loadedAssessment.accountId,
            assessmentId: loadedAssessment.assessmentId,
            prevId: loadedAssessment.id,
            surveyResultsJson: (keepAnswers == 'YES') ? loadedAssessment.surveyResultsJson : null
          });
          this._platformApi.saveAccountAssessment(undefined, newAccountAssessment).subscribe(accountAssessment => {
            loadedAssessment.nextId = accountAssessment.id;
            loadedAssessment.isLatest = false;
            this._platformApi.saveAccountAssessment(undefined, loadedAssessment).subscribe(prevAcctAssessment => {
              this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: loadedAssessment.accountId });
              this.cwdialog.spinner.hideSpinner();
              this.dialogRef.close();
            });
          })
      }
    });
  }

  assessmentInProgress(){
    this.cwdialog.spinner.hideSpinner();
    return this.assessmentTypeForm.controls.assessment.setErrors({invalid: true});
  }

  validateAccount() {
    this.isLoading=false;
    this.assessmentTypeForm.controls.assessment.setValue('');
    this.assessmentTypeForm.get('assessment').enable();
    this.assessmentTypeForm.controls.assessment.updateValueAndValidity();
    this.assessmentTypeForm.controls.assessment.markAllAsTouched();
  }
}